"use client";

import { useQuery } from "@tanstack/react-query";
import React, { useState } from "react";
import { Col } from "react-bootstrap";
import { fetchRelatedItems } from "../../../app/apis/getApis";
import ProductCardLoading from "../../SpecDetails/ProductCardLoading";
import styles from "../../../styles/ProductDetail.module.css";
import { useUserStore } from "../../../store/User";
import { useRouter } from "next/navigation";
import { marketplaceCdn } from "../../../utility/env";
import Link from "next/link";
import { trackListingVisit } from "../../../utility/UserEvents";
import { replaceSpecialCharacters } from "../../../utility/Images/utils";
import Image from "next/image";

const RelatedProducts = ({ paramId }: any) => {
  const FetchRelatedProducts = useQuery({
    queryKey: ["relatedProducts", paramId],
    queryFn: () => fetchRelatedItems(paramId),
    enabled: !!paramId?.toString(),
  });
  const relatedProducts = FetchRelatedProducts?.data?.data?.body?.data;

  return (
    <Col
      // xs="12"
      // sm="12"
      // md="12"
      // lg="4"
      className="mt-4 mt-lg-0 d-grid order-sm-1 order-1 order-lg-0 d-md-block"
    >
      {FetchRelatedProducts?.isSuccess && relatedProducts.length === 0 ? (
        <></>
      ) : (
        <>
          <h5
            className={` fs-18 mt-3 border-bottom text-center pb-1 ${styles.re_heading}`}
          >
            Related Models
          </h5>
          <div
            className={`d-flex flex-row flex-wrap p-1 gap-3 justify-content-center justify-content-lg-center`}
          >
            {FetchRelatedProducts.isLoading
              ? Array.from(Array(10)).map((item: any, index: number) => (
                  <ProductCardLoading key={index} />
                ))
              : relatedProducts?.map((item: any, index: number) => (
                  <ProductCard
                    key={index}
                    title={item.listing_title}
                    imageUrl={item.item.itemImages?.img0}
                    id={item.listing_id}
                    price={item.effective_price}
                    // category={category}
                  />
                ))}
          </div>
        </>
      )}
    </Col>
  );
};

export default RelatedProducts;

export const ProductCard = ({ title, id, imageUrl, price }: any) => {
  const { user, token } = useUserStore((state: any) => state);
  const router = useRouter();
  const [imageSrc, setImageSrc] = useState(`${marketplaceCdn}/${imageUrl}`);
  return (
    <Link
      onClick={() =>
        trackListingVisit(
          id,
          user?.uuid,
          "PDP",
          title,
          `${process.env.NEXT_PUBLIC_MARKETPLACE_URL}/products/${replaceSpecialCharacters(
            title.replaceAll(" ", "-").replaceAll("/", "").replaceAll("--", "")
          ).trim()}-${id}`
        )
      }
      href={`/products/${replaceSpecialCharacters(title.replaceAll(" ", "-").replaceAll("/", "").replaceAll("--", ""))}-${id}`}
    >
      <div
        style={{
          width: "128px",
          height: "200px",
          border: "1px solid #dee2e6",
          borderRadius: "10px",
          overflow: "hidden",
          cursor: "pointer",
        }}
      >
        <div style={{ width: "128px", height: "128px" }}>
          <Image
            alt="modelImage"
            src={imageSrc}
            width={300}
            height={300}
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
            onError={(e) => {
              setImageSrc(`${imagePlaceholder.src}`);
            }}
          />
        </div>
        <div className="d-flex flex-column">
          <p
            style={{
              margin: "0",
              padding: "0 5px",
              height: "40px",
              overflow: "hidden",
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 3, // Number of lines before applying ellipsis
              textOverflow: "ellipsis",
              fontSize: "0.8rem",
              fontWeight: "500",
            }}
          >
            {title}
          </p>
          <h5 className="fs-12 m-1 justify-content-end">
            Rs. <span className="fs-9">{price}</span>
          </h5>
        </div>
      </div>
    </Link>
  );
};
